// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gy7ku","left":"styles_left__2kHK-","desktopActions":"styles_desktopActions__1h8SD","title":"styles_title__3sqA3"};